module.exports = __webpack_public_path__ + "static/media/splice_files-warning.59be51b0.svg";